import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">

        {/* Top area: Blocks */}
        <div className="grid sm:grid-cols-12 gap-8 py-8 md:py-12 border-t border-gray-200">

          {/* 1st block */}
          <div className="sm:col-span-12 lg:col-span-3">
            <div className="mb-2">
              {/* Logo */}
              
              <img class="h-16 w-16 transform scale-150" src="https://i.vgy.me/QSZlmu.png" alt="Divine-Header-Logo"/>
              
            </div>
            <div className="text-sm font-bold text-white">Divine Bots LLC</div>
            
            <div className="text-sm text-white"> 
              <Link to="./terms" className="text-white hover:text-gray-400 hover:underline transition duration-150 ease-in-out">Terms</Link> · <Link to="./privacy" className="text-white hover:text-gray-400 hover:underline transition duration-150 ease-in-out">Privacy Policy</Link>
            </div>
          </div>

          
          {/* 3rd block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-3">
            <h6 className="text-white font-medium mb-2">Resources</h6>
            <ul className="text-sm">
              <li className="mb-2">
              <div className="text-white hover:text-gray-400 transition duration-150 ease-in-out"><a href = "https://po1ar.gitbook.io/divine-labs/">Documentation</a></div>
              </li>
              <li className="mb-2">
                <div className="text-white hover:text-gray-400 transition duration-150 ease-in-out"><a href="https://divine.statuspage.io">Status</a></div>
              </li>
              <li className="mb-2">
              <div className="text-white hover:text-gray-400 transition duration-150 ease-in-out"><a href = "https://discord.gg/WQfNTVzaMH">Support</a></div>
              </li>
            </ul>
          </div>

          {/* 4th block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
            <h6 className="text-white font-medium mb-2">Legal</h6>
            <ul className="text-sm">
              <li className="mb-2">
              <Link to="/cookies" className="text-white hover:text-gray-400 transition duration-150 ease-in-out">Cookie Policy</Link>
              </li>
              <li className="mb-2">
              <Link to="/returns" className="text-white hover:text-gray-400 transition duration-150 ease-in-out">Returns</Link>
              </li>
              <li className="mb-2">
                <Link to="/disclaimer" className="text-white hover:text-gray-400 transition duration-150 ease-in-out">Disclaimer</Link>
              </li>
            </ul>
          </div>

          {/* 5th block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-4">
            <h6 className="text-white font-medium mb-2">Get Notified on Restocks</h6>
            <p className="text-sm text-white mb-4">Be sure to follow us on twitter when we release. <a className="text-blue-600 hover:underline" href= "https://twitter.com/DivineBots"> @DivineBots</a></p>
            
              <div className="flex flex-wrap mb-4">
                <div className="w-full">
              
                </div>
              </div>
            
          </div>          

        </div>

        {/* Bottom area */}
        <div className="md:flex md:items-center md:justify-between py-4 md:py-8 border-t border-gray-200">

          

          {/* Copyrights note */}
          <div className="text-sm text-white mr-4">Made by <a className="text-blue-600 hover:underline" href="https://po1ar.dev/">polar</a>. All rights reserved.</div>

        </div>

      </div>
    </footer>
  );
}

export default Footer;
